import { FormLayout } from "@careinfo/layout";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm, UseFormSetError } from "react-hook-form";
import { INavigation } from "../../types/interface";
import { navigationValidation } from "../../utils/validationSchema";
import NavigationForm from "./Form";

interface Props {
  handleCreate: (
    data: INavigation,
    setError: UseFormSetError<INavigation>
  ) => Promise<void>;
  isCreatingNavigation: boolean;
}

export default function CreatePage({
  handleCreate,
  isCreatingNavigation,
}: Props) {
  const createNavigationMethods = useForm<INavigation>({
    resolver: yupResolver(navigationValidation),
  });

  return (
    <FormLayout
      isLoading={isCreatingNavigation}
      handleSubmit={createNavigationMethods.handleSubmit}
      handleFormSubmit={handleCreate}
      buttonLabel="Create"
      disabled={isCreatingNavigation}
      setError={createNavigationMethods.setError}
    >
      <FormProvider {...createNavigationMethods}>
        <NavigationForm />
      </FormProvider>
    </FormLayout>
  );
}
